import { CircleHelp } from 'lucide-react'

type HelpTooltipProps = {
  text: string
  label?: string
  align?: 'left' | 'center' | 'right'
  tone?: 'default' | 'light'
}

export function HelpTooltip({
  text,
  label = 'Afficher une explication',
  align = 'center',
  tone = 'default',
}: HelpTooltipProps) {
  return (
    <span className={`help-tooltip ${align} ${tone}`}>
      <button className="help-tooltip-trigger" type="button" aria-label={label}>
        <CircleHelp size={15} aria-hidden="true" />
      </button>
      <span className="help-tooltip-content" role="tooltip">{text}</span>
    </span>
  )
}
